var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLicensure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#3282A4",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17H15l-1 1v14l1 1h11l1-1H16V18h18v6c1 0 1 1 2 1v-7l-1-1h-1z",
    fill: "#3282A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21h11v1H18v-1zM18 24h7v1h-7v-1zM18 28h6v1h-6v-1zM31 24c-1 0-1 1-2 1l-2 2v3s1 1 1 2l-1 1 1 3 2-3h2l3 3 1-3-2-1c1-1 1-2 1-2 1-1 1-2 0-3 0-1-1-1-1-2-1 0-2-1-3-1zm0 8l-1-1c-1 0-1-1-1-1-1-1-1-1 0-2v-1c1-1 1-1 2-1h1c1 0 1 1 2 1v2s0 1-1 2c0 0-1 1-2 1z",
    fill: "#3282A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensure);
export default __webpack_public_path__ + "static/media/licensure.8e16483ecef7969b571b5354fd06a8b5.svg";
export { ForwardRef as ReactComponent };